import { REACT_APP_PERITADOR_API } from '../../config'
import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'

export async function getLockedPatent(patente) {

  let query1 = {
    where: {
      servicePatent: patente,
      locked: true
    },
  }

  const endpoint1 = encodeURI(`${REACT_APP_PERITADOR_API}/requests?filter=${JSON.stringify(query1)}`)
  const res_1 = await axios(endpoint1)
  let locked = res_1?.data.length ? true : false

  return deepFreeze( {locked} )
}